import { render, staticRenderFns } from "./ManageProjects.vue?vue&type=template&id=58968560&scoped=true&"
import script from "./ManageProjects.vue?vue&type=script&lang=js&"
export * from "./ManageProjects.vue?vue&type=script&lang=js&"
import style0 from "./ManageProjects.vue?vue&type=style&index=0&id=58968560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58968560",
  null
  
)

component.options.__file = "ManageProjects.vue"
export default component.exports